import { editOnly } from 'routing/constants'
import {
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID,
} from '../constants/siteStatuses'

export function getEditOnlyStatusId(site) {
  return (
    site?.SiteStatus?.id ??
    site?.SiteStatusId ??
    site?.siteStatusId ??
    null
  )
}

export function isEditOnlySiteStatus(statusId) {
  return (
    statusId === SITE_STATUS_EDIT_ONLY_ID ||
    statusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
  )
}

/**
 * True when the row looks like a SitesEditOnly record (parent siteId + own edit-only id).
 */
export function isEditOnlySiteRow(site) {
  if (!site) return false
  if (isEditOnlySiteStatus(getEditOnlyStatusId(site))) return true
  const parentId = site.siteId || site.SiteId || site.Site?.id
  return Boolean(parentId && site.id && parentId !== site.id && !site.reassessmentFlag)
}

export function getEditOnlyContext(site) {
  const editOnlySiteStatus = isEditOnlySiteRow(site)
  return {
    editOnlySite: editOnlySiteStatus ? editOnly : null,
    editOnlySiteStatus,
  }
}
